var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAttach(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M19 11.5008L11.9083 18.635C11.0396 19.509 9.86124 20 8.6326 20C7.40396 20 6.22564 19.509 5.35686 18.635C4.48808 17.761 4 16.5756 4 15.3396C4 14.1036 4.48808 12.9182 5.35686 12.0442L12.4485 4.91C13.0277 4.32734 13.8132 4 14.6323 4C15.4514 4 16.237 4.32734 16.8162 4.91C17.3954 5.49266 17.7207 6.28292 17.7207 7.10693C17.7207 7.93094 17.3954 8.7212 16.8162 9.30386L9.7168 16.4381C9.4272 16.7294 9.03443 16.8931 8.62488 16.8931C8.21534 16.8931 7.82256 16.7294 7.53297 16.4381C7.24338 16.1467 7.08068 15.7516 7.08068 15.3396C7.08068 14.9276 7.24338 14.5325 7.53297 14.2411L14.0845 7.6581",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAttach);
export default __webpack_public_path__ + "static/media/iconAttach.ca4b85b8e39084006937cba7303b7776.svg";
export { ForwardRef as ReactComponent };